import type { EventKind, SessionFormat } from '@ready/shared';

/** "Live webinar", "Live workshop", "3-session workshop". */
export function eventKindLabel(kind: EventKind, sessionCount: number): string {
  if (kind === 'webinar') return 'Live webinar';
  return sessionCount > 1 ? `${sessionCount}-session workshop` : 'Live workshop';
}

const SHORT_FORMAT: Record<SessionFormat, string> = {
  online: 'Online',
  in_person: 'In person',
  hybrid: 'Hybrid',
};

/** One word for an event's sessions: "Online", "In person" or "Hybrid" (also for a mix). */
export function formatsLabel(formats: SessionFormat[]): string | null {
  const unique = [...new Set(formats)];
  if (unique.length === 0) return null;
  return unique.length === 1 ? SHORT_FORMAT[unique[0]!] : 'Hybrid';
}

/** "3 seats left", "1 seat left", "Full: join the waitlist"; null without a seat limit. */
export function seatsText(seatsLeft: number | null): string | null {
  if (seatsLeft === null) return null;
  if (seatsLeft <= 0) return 'Full: join the waitlist';
  return `${seatsLeft} seat${seatsLeft === 1 ? '' : 's'} left`;
}

/** "Attend all sessions", "Attend at least 2 of 3 sessions", "Attend the session". */
export function certificateRequirement(minSessions: number | null, sessionCount: number): string {
  if (sessionCount <= 1) return 'Attend the session';
  if (minSessions === null || minSessions >= sessionCount) return 'Attend all sessions';
  return `Attend at least ${minSessions} of ${sessionCount} sessions`;
}

/** Google Maps search for a venue and address. */
export const mapsUrl = (query: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
